import { render, staticRenderFns } from "./IconButtonArrowDown.vue?vue&type=template&id=aba51d28"
import script from "./IconButtonArrowDown.vue?vue&type=script&lang=js"
export * from "./IconButtonArrowDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports